import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export default function DataExport() {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = pw.length >= 12 && pw === pw2;
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post("/enterprise/export", { passphrase: pw }, { responseType: "blob" });
      const name = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "ace-esign-export.acex";
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: name });
      a.click(); URL.revokeObjectURL(a.href);
      toast.success("Export downloaded (audited)"); setPw(""); setPw2("");
    } catch (e) { toast.error(e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="bg-white border rounded-xl p-4 space-y-3 max-w-2xl" data-testid="data-export">
      <p className="text-sm font-semibold">Export all data (for the move to Azure)</p>
      <p className="text-xs text-slate-600">Creates one encrypted file with every organization, staff record, form, patient, packet, file and audit log. Only the passphrase opens it, and it is never stored - keep it somewhere safe and share it with IT separately from the file. Turn maintenance mode on first so nothing changes during the move.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Passphrase (12+ characters)" data-testid="export-passphrase" autoComplete="new-password" />
        <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repeat passphrase" data-testid="export-passphrase-repeat" autoComplete="new-password" />
      </div>
      {pw2 && pw !== pw2 && <p className="text-xs text-red-700">Passphrases do not match.</p>}
      <Button className="btn-brand" disabled={!ok || busy} onClick={run} data-testid="export-download-btn">{busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Download className="w-4 h-4 mr-1" />}Download encrypted export</Button>
    </div>
  );
}
